interface mapper {
  unformattedObjects: any[]
  format: () => any
}

export default abstract class Mapper implements mapper {
  unformattedObjects: any[]

  constructor(unformattedObjects: any[]) {
    this.unformattedObjects = unformattedObjects
  }

  abstract format(): any
}
